import React from 'react'
import EnrollmentManagementModal from '../enrollment-management-modal'
import useClientLocation from '../../../hooks/use-client-location'

const ExperienceEnrollmentManagementScreen = () => {
    const { goBack, params } = useClientLocation()
    const experienceId = params.experienceId
    return (
        <EnrollmentManagementModal
            experienceId={experienceId}
            onClose={goBack}
        />
    )
}

export default ExperienceEnrollmentManagementScreen